import { useEffect } from 'react'
import { bannerStore } from 'shared/ui/Banner/store/bannerStore'

export const useDisableGlobalBanner = () => {
  useEffect(() => {
    bannerStore.setDisabledGlobal(true)

    return () => {
      bannerStore.setDisabledGlobal(false)
    }
  }, [])
}
